export default __webpack_public_path__ + "static/media/my-assessment-icon.bac77ae6.svg";